// extracted by mini-css-extract-plugin
module.exports = {"cover":"placeholder-image_cover__2QH9K"};